function noneFilter() {
  return true;
}

export { noneFilter as default };
